<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  <div>Datumreeks</div>
  <button mat-icon-button aria-label="Sluiten" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</h1>
<div mat-dialog-content>
  <mat-chip-listbox>
    @for (dateString of data.dateSequence; track dateString) {
      <mat-chip
        [class.date-warning]="hasWarning(dateString) || hasDaypartStatus(dateString, 'finished')"
        [class.secondary-color]="
          (hasDaypartStatus(dateString, 'updated') || hasDaypartStatus(dateString, 'removed')) &&
          !hasWarning(dateString)
        "
        [matTooltip]="data.warnings[dateString]?.message"
      >
        {{ dateString }}
      </mat-chip>
    }
  </mat-chip-listbox>
</div>
